/**
 * Stable workflow action keys — must match public.workflow_action_definitions.action_key
 * and seed migration. UI labels can come from DB; this file validates keys in code.
 */

export const WORKFLOW_ACTION_KEYS = [
  'submit_case',
  'confirm_phase',
  'reject_phase',
  'assign_operator',
  'assign_self_case',
  'assign_prosthetist',
  'assign_production_staff',
  'open_stl_preview',
  'open_crm_studio',
  'assign_package',
  'save_design_url',
  'open_ipr_milestone',
  'open_production_sheet',
  'add_milestone_note',
  'modify_case_files',
];

/** @param {string} key */
export function isValidWorkflowActionKey(key) {
  return typeof key === 'string' && WORKFLOW_ACTION_KEYS.includes(key);
}

/** Role types aligned with user_roles.role_type (admin UI + RLS-adjacent checks) */
export const WORKFLOW_ROLE_TYPES = [
  'administrator',
  'agent_administratif',
  'dentist_client',
  'dentist_supplier',
  'operator_3d',
  'operator_thermo',
  'operator_finition',
  'operator_qualite',
  'livraison',
  'production_responsible',
  'logistics_coordinator',
  'distributor',
  'production_supplier',
];
